// Utility functions for URL generation

/**
 * Generate collection slug from collection name
 * @param {string} collectionName - The collection name
 * @returns {string} - Slugified collection name
 */
export const generateCollectionSlug = (collectionName) => {
  if (!collectionName) return '';
  return collectionName
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
};

/**
 * Generate product detail URL with collection and product slug
 * @param {string} collectionSlug - The collection slug
 * @param {string} productSlug - The product slug
 * @returns {string} - Complete product detail URL path
 */
export const generateProductDetailUrl = (collectionSlug, productSlug) => {
  if (!collectionSlug || !productSlug) return '/';
  return `/${collectionSlug}/${productSlug}`;
};

/**
 * Get collection slug from collection object or name
 * @param {object|string} collection - Collection object with slug property or collection name
 * @returns {string} - Collection slug
 */
export const getCollectionSlug = (collection) => {
  if (!collection) return '';
  
  if (typeof collection === 'object') {
    return collection.slug || generateCollectionSlug(collection.name || collection.Collection_Name);
  }
  
  return generateCollectionSlug(collection);
};

/**
 * Parse collection and product slug from URL pathname
 * @param {string} pathname - URL pathname (e.g., "/12mm-fuzion-atlantis-laminate/horizon-fuzion-flooring")
 * @returns {object} - Object with collectionSlug and productSlug
 */
export const parseProductUrl = (pathname) => {
  const parts = pathname.split('/').filter(Boolean);
  
  if (parts.length >= 2) {
    return {
      collectionSlug: parts[0],
      productSlug: parts[1]
    };
  }
  
  return {
    collectionSlug: null,
    productSlug: parts[0] || null
  };
};
